/**
 * Shared configuration for Decisively modules that can be used as connections
 * in both Integration and Communication forms.
 */

export interface DecisivelyModule {
  key: string;
  value: string;
}

/**
 * List of available Decisively modules that can be selected as connections
 */
export const DECISIVELY_MODULES: DecisivelyModule[] = [
  {
    key: "EdWard",
    value: "edward"
  }
];

/**
 * Check if a given connection value is a Decisively module
 */
export const isDcsvlyModule = (connectionValue: string | undefined): boolean => {
  if (!connectionValue) return false;
  return DECISIVELY_MODULES.some(module => module.value === connectionValue);
};

/**
 * Combine Decisively modules with release connections for use in dropdowns
 */
export const getCombinedConnections = (releaseConnections?: Array<{ id: string; name: string }>) => {
  const connectionOptions = releaseConnections?.map(it => ({ key: it.name, value: it.id })) ?? [];
  return [...DECISIVELY_MODULES, ...connectionOptions];
};

